import { ColumnDef } from "@tanstack/react-table";
import { toast } from "sonner";

import { Badge } from "../ui/badge.tsx";
import { Button } from "../ui/button.tsx";
import { Checkbox } from "../ui/checkbox.tsx";

import image from "@/assets/images/coming-soon.png";
import { CustomTable } from "@/components/reusables/data-table/CustomTable.tsx";
import { usePagination } from "@/hooks/usePagination.ts";
import { IProject } from "@/interfaces/project.interface.ts";

type TProps = {
  title?: string;
};

const UnderConstruction = ({ title }: TProps): React.JSX.Element => {
  const pagination = usePagination({
    limit: 10,
    offset: 0,
    currentPage: 1,
    totalPages: 1,
    totalResult: 0,
  });

  return (
    <div>
      {title && (
        <div className='flex items-center gap-4'>
          <h2 className='text-xl font-medium 3xl:text-2xl'>{title}</h2>
          <Badge className='text-[#FFA61C] bg-[#FFF9D9]'>Coming Soon</Badge>
        </div>
      )}
      <div className='mt-6'>
        <CustomTable
          empty={{
            subtitle: "Feature is under construction",
          }}
          hide={{
            filters: false,
            functions: false,
          }}
          title='Under Construction'
          functions={{
            pagination,
          }}
          customEmptyLayout={
            <div className='flex flex-col items-center justify-center gap-6 py-32'>
              <img src={image} />

              <h3 className='text-2xl font-medium'>
                We&apos;re working on it.
              </h3>
              <p className='text-lg font-medium text-aldgray'>
                If you want to give requirements in this feature, please open
                link to write it down.
              </p>
              <div className='space-y-4'>
                <div className='flex items-center gap-4'>
                  <p className='px-6 py-2 font-semibold underline border rounded-md'>
                    https://forms.gle/zidkpNCAiUZRGCxH7
                  </p>
                  <Button
                    variant='outline'
                    className='bg-white text-primary border-primary'
                    onClick={() => {
                      navigator.clipboard
                        .writeText("https://forms.gle/zidkpNCAiUZRGCxH7")
                        .then(() => {
                          toast.info("Link copied to clipboard successfully!");
                        })
                        .catch(() => {
                          toast.error("Failed to copy link.");
                        });
                    }}
                  >
                    Copy Link
                  </Button>
                </div>
                <Button asChild>
                  <a
                    href='https://forms.gle/zidkpNCAiUZRGCxH7'
                    target='_blank'
                    rel='noreferrer'
                  >
                    Yes, Let&apos;s Give Requirement
                  </a>
                </Button>
              </div>
            </div>
          }
          data={[]}
          columns={
            [
              {
                id: "select",
                header: ({ table }): React.JSX.Element => (
                  <Checkbox
                    checked={
                      table.getIsAllPageRowsSelected() ||
                      (table.getIsSomePageRowsSelected() && "indeterminate")
                    }
                    onCheckedChange={(value) =>
                      table.toggleAllPageRowsSelected(!!value)
                    }
                    aria-label='Select all'
                  />
                ),
                cell: ({ row }): React.JSX.Element => (
                  <Checkbox
                    checked={row.getIsSelected()}
                    onCheckedChange={(value) => row.toggleSelected(!!value)}
                    aria-label='Select row'
                  />
                ),
                enableSorting: false,
                enableHiding: false,
              },
              {
                accessorKey: "name",
                header: "Column 1",
                enableSorting: false,
              },

              {
                accessorKey: "projectNumber",
                header: "Column 2",
                enableSorting: false,
              },
              {
                accessorKey: "referenceNumber",
                header: "Column 3",
                enableSorting: false,
              },
              {
                accessorKey: "address",
                header: "Column 4",
                enableSorting: false,
              },
              {
                accessorKey: "budgetHours",
                header: "Column 5",
                enableSorting: false,
              },
            ] as ColumnDef<IProject>[]
          }
        />
      </div>
    </div>
  );
};

export default UnderConstruction;
